<template>
  <div :style="{ width: width }" class="part-title">
    <div class="title" :style="{ marginLeft: left }">{{ title }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'auto'
    },
    left: {
      type: String,
      default: '0px'
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.part-title {
  position: relative;
  height: 78px;
  display: flex;
  // justify-content: center;
  margin-left: 80px;
  align-items: center;
  background-image: url("~@/assets/images/title_bg.png");
  background-position: center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;

  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 30px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    padding-left: 60px;
  }
}

@media screen and (max-width: 767px) {
  .part-title {
    position: relative;
    padding: 20px;
    display: flex;
    width: 75% !important;
    margin: 0 !important;
    text-align: center;
    align-items: center;
    background-image: url("~@/assets/images/title_bg.png");
    background-position: center;
    background-size: 100% 100%;

    .title {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      line-height: 55px;
      text-align: center;
      font-style: normal;
      margin-left: 0px!important;
      padding-left: 0;
      text-align: center;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/PartTitle.vue